/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Feedback {
	/** @example "sharefile:account-123" */
	forResourceRID: string;
	type: FeedbackType;
	comment?: string | null;
}

export enum FeedbackType {
	Like = 'like',
	Dislike = 'dislike',
}

export enum ModelInvocationStatus {
	Unknown = 'unknown',
	Ok = 'ok',
	RuntimeError = 'runtimeError',
	DeclinedHarmful = 'declinedHarmful',
	DeclinedMisuse = 'declinedMisuse',
	DeclinedUnknown = 'declinedUnknown',
	DeclinedInputTooLong = 'declinedInputTooLong',
}

export interface ProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	[key: string]: any;
}

export interface Reference {
	/** @minLength 1 */
	reference_sentence: string;
	/**
	 * @format int32
	 * @min 0
	 * @max 2147483647
	 */
	reference_number: number;
	context_sentence_before?: string | null;
	context_sentence_after?: string | null;
}

/** The type of authentication to use when authenticating. */
export enum ShareFileAuthType {
	User = 'user',
	System = 'system',
}

export interface Statement {
	/** @minLength 1 */
	sentence: string;
	reference_numbers?: number[] | null;
}

export interface StatusRecord {
	/** @format uuid */
	taskId?: string;
	/** @example "sharefile:account-123" */
	accountRID?: string | null;
	/** @example "sharefile:account-123" */
	userRID?: string | null;
	/** @format date-time */
	createdAt?: string;
	/** @format date-time */
	updatedAt?: string;
	status?: SummarizationJobStatus;
	result?: ModelInvocationStatus;
	/** @example "sharefile:account-123" */
	resourceId?: string | null;
	/** @example "sharefile:account-123" */
	summaryRID?: string | null;
	errorMessage?: string | null;
}

export enum SummarizationJobStatus {
	Unknown = 'unknown',
	Received = 'received',
	Processing = 'processing',
	Completed = 'completed',
	Failed = 'failed',
}

export interface Summary {
	/**
	 * Unique identifier of the resource.
	 * @example "sharefile:account-123"
	 */
	RID?: string | null;
	/**
	 * A timestamp for when the resource was created.  This value is set internally and cannot be modified.
	 * @format date-time
	 */
	createdAt?: string | null;
	/**
	 * A timestamp for when the resource was last updated.  This value is set internally and cannot be modified.
	 * @format date-time
	 */
	updatedAt?: string | null;
	/**
	 * Unique identifier of the User that created the resource.  This value is set internally and cannot be modified.
	 * @example "sharefile:account-123"
	 */
	creatorRID?: string | null;
	/**
	 * Unique identifier of the User that last updated the resource.  This value is set internally and cannot be modified.
	 * @example "sharefile:account-123"
	 */
	updaterRID?: string | null;
	/**
	 * A timestamp that identifies when the next lifecycle state change should occur.
	 * @format date-time
	 */
	expiresAt?: string | null;
	/** The current lifecycle state of the resource.  This value is set internally and cannot be modified. */
	lifecycleState?: 'active' | 'recycleBin' | 'purged' | null;
	/** @example "sharefile:account-123" */
	related_resource_id: string;
	/** @minItems 1 */
	summarization: Statement[];
	references?: Reference[] | null;
}

/** This object is utilized by the paged API calls to return a list of resources and the next skip value. */
export interface SummaryResourcePagedResult {
	/**
	 * The skip value that should be passed to get the next sequential page of resources.
	 * @format int32
	 */
	nextSkip?: number | null;
	/** The page of resources that were found. */
	resources?: Summary[] | null;
}

export interface SummaryResponse {
	completed?: boolean;
	status?: StatusRecord;
	summary?: Summary;
}

export interface ValidationProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	errors?: Record<string, string[]>;
	[key: string]: any;
}
